/* eslint-disable no-useless-catch */
/* eslint-disable unused-imports/no-unused-vars */
import { DTS_FILE_UPLOAD, DTS_REQUEST_URL } from "../constants/url.constant";

import { API } from "../api";

export const GET_ALL_DTS_REQUEST = "GET_ALL_DTS_REQUEST";
export const DELETE_DTS_REQUEST = "DELETE_DTS_REQUEST";

export const uploadAWBFile = (fileData) => {
  return async (dispatch) => {
    try {
      return await API.post(DTS_FILE_UPLOAD, fileData);
    } catch (error) {
      throw error;
    }
  };
};

export const createDTSRequest = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.post(DTS_REQUEST_URL, data);
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const getAllDTSRequest = (params = {}) => {
  return async (dispatch) => {
    try {
      const res = await API.get(DTS_REQUEST_URL, {
        params: params
      });
      dispatch({
        type: GET_ALL_DTS_REQUEST,
        payload: res
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const getDTSRequestById = (id) => {
  return async (dispatch) => {
    try {
      const res = await API.get(`${DTS_REQUEST_URL}/${id}`);
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const updateDTSRequest = (id, data) => {
  return async (dispatch) => {
    try {
      const res = await API.put(`${DTS_REQUEST_URL}/${id}`, data);
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const removeDTSRequestOrder = (orderId, id) => {
  return async (dispatch) => {
    try {
      const res = await API.delete(`${DTS_REQUEST_URL}/${orderId}/${id}`);
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const removeDTSRequest = (id) => {
  return async (dispatch) => {
    try {
      const res = await API.delete(`${DTS_REQUEST_URL}/${id}`);
      dispatch({
        type: DELETE_DTS_REQUEST,
        payload: id
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

const initialState = {
  columns: [],
  data: [],
  totalRows: 0,
  order: {}
};

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case GET_ALL_DTS_REQUEST:
      return {
        ...state,
        columns: payload.columns,
        data: payload.rows,
        totalRows: payload.count
      };
    case DELETE_DTS_REQUEST:
      return {
        ...state,
        totalRows: state.totalRows - 1,
        data: state.data.filter((bag) => bag.id !== payload)
      };
    default:
      return state;
  }
}
